import React, { useEffect, useState } from "react";
import useInputKeys from "hooks/useInputKeys";
import InputBase from "@mui/material/InputBase";
import "./index.scss";
import { useSearchTimelines } from "hooks/timeline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import HighlightedText from "./HighlightedText";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";

function Screen({ activeSearch }) {
  const {
    strInput,
    setStrInput,
    setKeyTimelineId,
    resetSelectedTimeline,
    direction,
    handleClearStr,
  } = useInputKeys();
  const [warning, setWarning] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [data, setData] = useState(null);
  const [items, setItems] = useState([]);
  const [animation, setAnimation] = useState("slide-in");
  const [wink, setWink] = useState(true);
  const theme = useTheme();
  const { t } = useTranslation();

  const { mutate: searchTimelines, data: searchTimelinesData } =
    useSearchTimelines();

  const sendRequest = () => {
    if (strInput.length >= "3") {
      searchTimelines({
        searchQuery: strInput.toLowerCase(),
        band: "original",
      });
      setWarning(false);
    }
    if (strInput.length < "3") {
      setWarning(true);
    }
  };

  useEffect(() => {
    setData(searchTimelinesData);
    if (searchTimelinesData?.timelines.length === 0) {
      setNotFound(true);
    }
    if (searchTimelinesData && searchTimelinesData.timelines?.length > 0) {
      setAnimationClass("expand");
    } else if (
      data === null ||
      data?.timelines?.length === searchTimelinesData?.timelines?.length
    ) {
      setAnimationClass("");
    } else if (
      data?.timelines?.length >= searchTimelinesData?.timelines?.length
    ) {
      setAnimationClass("collapse");
    }
    if (data) {
      setAnimation("slide-out");
      setTimeout(() => {
        setItems(data);
        setAnimation("slide-in");
      }, 300);
    }
  }, [searchTimelinesData, data]);

  useEffect(() => {
    if (warning) {
      setItems([]);
      setAnimationClass("collapse");
    }
  }, [warning]);

  useEffect(() => {
    setNotFound(false);
    if (strInput.length >= "3") {
      setWarning(false);
    }
  }, [strInput]);

  useEffect(() => {
    if (activeSearch) {
      setStrInput("");
    }
  }, [activeSearch, setStrInput]);

  useEffect(() => {
    setTimeout(() => {
      setWink(!wink);
    }, 500);
  }, [wink]);

  const handleClick = (timeline) => {
    resetSelectedTimeline();
    setKeyTimelineId(timeline.timelineId);
  };

  return (
    <div
      className={`parent-search ${
        direction === "ltr" ? "ltr-style" : "rtl-style"
      }`}
    >
      <div className="search-input-wrapper">
        <InputBase
          fullWidth
          readOnly
          className="search-input"
          value={`${strInput}${wink ? "_" : ""}`}
        />
        <div
          onClick={sendRequest}
          className="search-button"
          style={{ zIndex: "2" }}
        >
          {t("search")}
        </div>
        <div
          className={`backSpace-icon ${strInput.length > 0 ? "" : "hide"}`}
          onClick={handleClearStr}
        >
          <BackspaceIcon
            className="icon"
            style={{ color: theme.palette.primary.main }}
          />
        </div>
      </div>
      {(warning || notFound) && (
        <>
          {warning && (
            <div className="tooltip" style={{ color: theme.palette.info.main }}>
              <InfoOutlinedIcon className="icon" />
              <span>{t("atLeasteCharacters")}</span>
            </div>
          )}
          {notFound && (
            <div
              className="tooltip"
              style={{ color: theme.palette.error.main }}
            >
              <ErrorOutlineOutlinedIcon />
              <span dir="ltr">
                "{strInput}" {t("notFound")}
              </span>
            </div>
          )}
        </>
      )}

      {data && (
        <div className={`search-result ${animationClass}`}>
          {items &&
            items.timelines?.map((item, index) => (
              <div
                key={index}
                onClick={() => handleClick(item)}
                className={`item-result ${animation}`}
                style={{ border: `1px solid ${theme.palette.primary.main}` }}
              >
                <HighlightedText text={item.title} highlight={strInput} />
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export default Screen;
